import React from 'react';
import BaseButton, { BaseButtonProps } from '@tcl-argon-foundations/base-button';
import { InputTheme } from '@tcl-argon-models/models';
import { getButtonColorsForTheme, getFlipButtonColorsForTheme } from './theme';

export interface ButtonProps
  extends Omit<BaseButtonProps, 'activeColors' | 'defaultColors' | 'hoverColors' | 'minWidth'> {
  /** Control the expression of this button's theme by swapping the background and text colors. */
  isInverted?: boolean;
  /**
   * A theme that represents a button's text, background, and border colors.
   * Works just like any other input's theme prop. Affects styles only.
   */
  theme?: InputTheme;
  /**
   * Minimum width of the button defaults to 100px but can be overridden if needed
   */
  minWidth?: string;
}

export const Button: React.FC<ButtonProps> = ({
  theme = InputTheme.Tempus,
  isInverted = false,
  minWidth = '100px',
  ...props
}) => {
  const { activeColors, hoverColors, defaultColors } = isInverted
    ? getFlipButtonColorsForTheme(theme)
    : getButtonColorsForTheme(theme);

  return (
    <BaseButton
      activeColors={activeColors}
      data-analytics="button"
      defaultColors={defaultColors}
      hoverColors={hoverColors}
      minWidth={minWidth}
      {...props}
    />
  );
};

Button['isButton'] = true;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isButton(component: any): component is React.ReactElement<ButtonProps> {
  return component.type?.isButton === true;
}
